document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[js-accordion]');

  accordions?.forEach((accordion) => {
    const header = accordion.querySelector('[js-accordion-header]');
    const content = accordion.querySelector('[js-accordion-content]');

    if (!header || !content) {
      return;
    }

    header.addEventListener('click', (e) => {
      e.preventDefault();

      const isActive = accordion.classList.contains('open');

      accordions.forEach((acc) => {
        acc.classList.remove('open');
        const accordionContent = acc.querySelector('[js-accordion-content]');

        if (!accordionContent) {
          return;
        }

        accordionContent.style.maxHeight = 0;
      });

      if (!isActive) {
        accordion.classList.add('open');
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });
  });
});
